module.exports = "/_next/static/images/1ec3276426f1fa5c59ffc0422001ccc3-exemplo_rotativo.png";